export const shouldPrioritiseFirstTile = (prioritiseFirstTile, index) =>
  !!(index === 0 && prioritiseFirstTile)
